import React from 'react'
import Layout from '../../pages/Layout/layout'
import vc1 from '../../images/vc1.jpg'

// 👇 import your videos
import video1 from '../../images/video1.mp4'
import video2 from '../../images/video2.mp4'
import './style.css'

const Video_gallery = () => {
  return (
    <Layout>

      {/* HERO SECTION */}
      <div
        style={{
          backgroundImage: `url(${vc1})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          paddingBottom: '50px',
          paddingTop: '100px',
          height: '60vh'
        }}
      >
      </div>

      {/* VIDEO SECTION */}
      <div className='uk-container'>
        <div className='uk-grid uk-margin-large-top'>

          <div className='uk-width-1-2@s'>
            <video width="100%" height="315" className="video-player" controls>
              <source src={video1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='uk-width-1-2@s'>
            <video width="100%" height="315" className="video-player" controls>
              <source src={video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

        </div>
      </div>

    </Layout>
  )
}

export default Video_gallery